<template>
  <div id="contenedor-main-pagos">
    <v-container
      fluid>
      <v-card
        flat
        class="mb-4">
        <v-card-text>
          <titulo-tool-bar
            titulo="Pagos">
            <template
              v-slot:opciones-derecha>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    @click="mostrarVentanaExcelPagos = !mostrarVentanaExcelPagos">
                    <v-icon> mdi-file-excel </v-icon>
                  </v-btn>
                </template>
                <span> Exportar Pagos </span>
              </v-tooltip>
            </template>
          </titulo-tool-bar>
          <tool-bar
            :proveedores="listadoProveedoresConPago"
            :filtros="filtros"
            @nuevoPago="mostrarNuevoPago = true">
          </tool-bar>
        </v-card-text>
      </v-card>
      <!-- Contenido -->
      <v-card
        flat>
        <v-card-text>
          <v-skeleton-loader
            v-if="$apollo.loading"
            type="table-heading, table-tbody">
          </v-skeleton-loader>
          <listado
            v-else
            :listado="listadoPagos">
          </listado>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog
      v-if="mostrarNuevoPago"
      v-model="mostrarNuevoPago"
      scrollable
      persistent
      width="60%">
      <v-card>
        <v-card-title class="secondary--text">
          Registrar nuevo pago
          <v-spacer></v-spacer>
          <v-btn icon @click="$refs.registrarNuevoPago.cerrar()">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <nuevo-pago
            ref="registrarNuevoPago"
            @cerrar="cerrarNuevoPago">
          </nuevo-pago>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            tipo="formCancelar"
            label="Cerrar"
            class="mr-3"
            @click="$refs.registrarNuevoPago.cerrar()">
          </custom-button>
          <custom-button
            tipo="formAceptar"
            label="Guardar"
            @click="$refs.registrarNuevoPago.guardar()">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-if="estePago"
      v-model="mostrarBorrarPago"
      :width="!$vuetify.breakpoint.mobile ? '450' : '90%'">
      <eliminar-pagos
        :pagoEliminar="estePago"
        :tipo="tipoPago"
        v-on:cerrar="cerrarEliminarPago">
      </eliminar-pagos>
    </v-dialog>
    <v-dialog
      v-if="mostrarVentanaExcelPagos"
      v-model="mostrarVentanaExcelPagos"
      width="400">
      <excel-pagos
      :listadoPagos="listadoPagosExcel"
      :filtros="filtros"
      v-on:cerrar="mostrarVentanaExcelPagos = !mostrarVentanaExcelPagos">
      </excel-pagos>
    </v-dialog>
  </div>
</template>

<script>
import PAGOS from '@/graphql/querys/administracion/pagos/pagos.gql';
import NuevoPago from '@/components/administracion/pagos/pagos/Nuevo.vue';
import CustomButton from '@/components/buttons/Button.vue';
import TituloToolBar from '@/components/TituloToolBar.vue';
import eventBus from '@/helpers/eventBus';
import EliminarPagos from '@/components/administracion/pagos/pagos/Eliminar.vue';
import ExcelPagos from '@/components/exportar/exceles/ExcelPagos.vue';
import mixPagos from '@/components/administracion/pagos/mixPagos';
import listado from './listado/Main.vue';
import ToolBar from './ToolBar.vue';

export default {
  name: 'MainPagos',
  mixins: [mixPagos],
  components: {
    NuevoPago,
    CustomButton,
    TituloToolBar,
    listado,
    ToolBar,
    EliminarPagos,
    ExcelPagos,
  },
  data() {
    return {
      mostrarNuevoPago: false,
      mostrarBorrarPago: false,
      mostrarVentanaExcelPagos: false,
      estePago: null,
      tipoPago: null,
      filtros: {
        idContratista: '',
        ejercicio: new Date().getFullYear(),
        buscarTexto: '',
      },
    };
  },
  apollo: {
    pagos: {
      query: PAGOS,
    },
  },
  methods: {
    cerrarNuevoPago() {
      this.mostrarNuevoPago = false;
    },
    cerrarEliminarPago() {
      this.mostrarBorrarPago = false;
      this.estePago = null;
      this.tipoPago = null;
    },
  },
  computed: {
    listadoPagosExcel() {
      if (!this.pagos) return [];
      return this.pagos
        .map((pago) => ({
          ...pago,
          detalles: pago.detalles.map((detalle) => {
            let contrato = null;
            let tipo = null;

            if (detalle.pagoSolicitudDetalle.anticipo) {
              tipo = 'Anticipo';
              contrato = detalle.pagoSolicitudDetalle.anticipo.contrato;
            }

            if (detalle.pagoSolicitudDetalle.estimacion) {
              tipo = 'Estimación';
              contrato = detalle.pagoSolicitudDetalle.estimacion.contrato;
            }
            if (detalle.pagoSolicitudDetalle.escalatoria) {
              tipo = 'Escalatoria';
              contrato = detalle.pagoSolicitudDetalle.escalatoria.contrato;
            }
            if (detalle.pagoSolicitudDetalle.gasto) {
              tipo = 'Gasto';
              contrato = detalle.pagoSolicitudDetalle.gasto.contrato;
            }

            return {
              ...detalle,
              contrato,
              tipo,
            };
          }),
        }))
        .slice()
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    },
    listadoPagos() {
      if (!this.pagos) return [];
      return this.pagos
        .map((pago) => ({
          ...pago,
          detalles: pago.detalles.map((detalle) => {
            let contrato = null;
            let tipo = null;
            let color = null;

            if (detalle.pagoSolicitudDetalle.anticipo) {
              tipo = 'Anticipo';
              color = 'green darken-1';
              contrato = detalle.pagoSolicitudDetalle.anticipo.contrato;
            }

            if (detalle.pagoSolicitudDetalle.estimacion) {
              tipo = 'Estimación';
              color = 'light-blue darken-1';
              contrato = detalle.pagoSolicitudDetalle.estimacion.contrato;
            }

            if (detalle.pagoSolicitudDetalle.escalatoria) {
              tipo = 'Escalatoria';
              color = 'brown darken-1';
              contrato = detalle.pagoSolicitudDetalle.escalatoria.contrato;
            }

            if (detalle.pagoSolicitudDetalle.gasto) {
              tipo = 'Gasto';
              color = 'pink darken-1';
              contrato = detalle.pagoSolicitudDetalle.gasto.contrato;
            }

            return {
              ...detalle,
              contrato,
              tipo,
              color,
            };
          }),
        }))
        .slice()
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        .filter((pago) => {
          // Filtrar por ejercicio
          const fecha = new Date(`${pago.fecha} 00:00:0`);
          const ejercicio = fecha.getFullYear();

          return this.filtros.ejercicio === ejercicio;
        })
        .filter((pago) => {
          // Filtrar por proveedor
          if (!this.filtros.idContratista) return true;

          return this.filtros.idContratista === pago.idContratista;
        })
        .filter((pago) => {
          if (!this.filtros.buscarTexto) return true;

          const expt = new RegExp(this.filtros.buscarTexto, 'gi');
          const referencia = this.$normalizacionTexto(pago.referencia);
          const contratista = this.$normalizacionTexto(pago.contratista.nombreRazonSocial);

          return (
            expt.test(pago.referencia)
            || expt.test(pago.contratista.nombreRazonSocial)
            || expt.test(referencia)
            || expt.test(contratista)
          );
        });
    },
    listadoProveedoresConPago() {
      if (!this.pagos) return [];
      const proveedores = this.$removerDumplicadosArrayObj(this.pagos, 'idContratista');

      return proveedores.map(({ contratista }) => contratista);
    },
  },
  mounted() {
    eventBus.$on('borrar-pago', (pago) => {
      this.tipoPago = 'pago';
      this.estePago = pago;
      this.mostrarBorrarPago = true;
    });
    eventBus.$on('borrar-detalle-pago', (detalle) => {
      this.tipoPago = 'detalle de pago';
      this.estePago = detalle;
      this.mostrarBorrarPago = true;
    });
  },
};
</script>

<style lang="scss">

</style>
